import { useState } from 'react';
import { useModal } from '../contexts';
import TextInputField from './TextInputField';
import IconPickerField from './IconPickerField';
import ColorPickerField from './ColorPickerField';
import Modal from './Modal';
import { BasicWorkflow, Workflow } from '../interfaces';
import { useTranslation } from 'react-i18next';
import TextAreaField from './TextAreaField';

interface Props {
  updateWorkflow: ((workflow: Workflow) => void) | ((workflow: BasicWorkflow) => void),
  workflow: Workflow,
  acceptText?: string,
  titleText?: string,
}

function WorkflowModalEdit(props: Props) {
  const [workflow, setWorkflow] = useState<Workflow>(props.workflow);
  const { t } = useTranslation();
  const { closeModal } = useModal();

  return (
    <Modal
      title={props.titleText ?? t("Update Workflow")}
      primaryButtonProps={{
        text: props.acceptText ?? t('Update'),
        onClick: () => { props.updateWorkflow(workflow); },
        disabled: workflow.name.trim() === '',
      }}
      secondaryButtonProps={{ text: t("Cancel"), onClick: closeModal }}
    >
      <TextInputField label="Workflow Name" value={workflow.name} onChange={(name) => setWorkflow((w: any) => ({ ...w, name }))} required />
      <div className='flex flex-col mt-2'>
        <div className="text-gray-600 font-gilroy font-semibold text-sm mb-2">
          Appearance
        </div>
        <div className="flex gap-4 items-start -mb-2">
          <ColorPickerField value={workflow.color} onChange={(color) => setWorkflow((w: any) => ({ ...workflow, color }))} />
          <IconPickerField value={workflow.icon} onChange={(icon) => setWorkflow((w: any) => ({ ...workflow, icon }))} selectColour={workflow.color} />
        </div>
      </div>
      <TextAreaField label={t('Workflow Description')} placeholder={t('Optionally provide a desciption for the purpose of this workflow')} value={workflow.description} onChange={(description) => setWorkflow((w: any) => ({ ...w, description }))} rows={3} optional />
    </Modal>
  );
}

export default WorkflowModalEdit;
